import { SearchRounded } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { INTERACTIVE_CLASSNAME_SUFFIX } from "components/WarehouseElements/Grid/InteractiveGridElement/InteractiveGridElement";
import { Severity } from "constants/Severity";
import { TestIds } from "constants/Tests/TestIds";
import { useAppDispatch, useAppSelector } from "hooks/StoreHooks";
import React, { useRef, useState } from "react";
import { useLazyGetElementContainerIdQuery } from "services/api/warehouseApi";
import { selectStoreNb } from "store/Selectors/locationsSelector";
import { getWarehousePlan } from "store/Selectors/warehousePlanSelector";
import { setSearchedItemId } from "store/Slices/gridEventSlice";
import { Shortcuts } from "./Shortcuts/Shortcuts";

import { NotificationType } from "constants/NotificationConstants";
import { NotificationReceivedEvent } from "events/Event";
import { NotificationResource } from "models/Resources/NotificationResource";
import "./WarehouseSearchHeaders.scss";

const UNFOUND_ELEMENT_SNACKBAR_DURATION = 3 * 1000;

export default function WarehouseSearchZone() {
  const inputFieldRef = useRef(null);

  const [searchedId, setSearchedId] = useState("");
  const storeNb = useAppSelector(selectStoreNb);
  const warehousePlan = useAppSelector(getWarehousePlan);

  const [onIdSearch] = useLazyGetElementContainerIdQuery();

  const dispatch = useAppDispatch();

  const onChangeSearchId = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setSearchedId(e.target.value);
  };

  const handleIdSearch = async () => {
    const isIdInPlan = warehousePlan.plan?.elements.find(
      e => e.id.toUpperCase() == searchedId.toUpperCase()
    );
    if (isIdInPlan) {
      document
        .getElementsByClassName(
          `${searchedId.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
        )[0]
        ?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      dispatch(setSearchedItemId(searchedId));
    } else {
      try {
        const containerId = await onIdSearch({
          elementId: searchedId,
          storeNb: storeNb,
        }).unwrap();
        const elem = document
          .getElementsByClassName(
            `${containerId.localisation.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
          )[0]
        if (elem) {  
          document
            .getElementsByClassName(
              `${containerId.localisation.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
            )[0]
            ?.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
          dispatch(setSearchedItemId(containerId.localisation));
        } else {
          if (containerId.texte) {
            const notificationResource: NotificationResource = {
              notificationId: String(Date.now()),
              title: `${containerId.texte}`,
              warehouse: storeNb,
              type: NotificationType.MESSAGE,
              severity: Severity.INFO,
              duration: UNFOUND_ELEMENT_SNACKBAR_DURATION,
              text: "",
              sentDate: new Date()
            };
            NotificationReceivedEvent.publish(notificationResource);
          }
        }
      } catch (err) {
        const notificationResource: NotificationResource = {
          notificationId: String(Date.now()),
          title: `L'élément ${searchedId} n'a pas été trouvé dans le plan.`,
          warehouse: storeNb,
          type: NotificationType.MESSAGE,
          severity: Severity.WARNING,
          duration: UNFOUND_ELEMENT_SNACKBAR_DURATION,
          text: "",
          sentDate: new Date(),
        }
          
        NotificationReceivedEvent.publish(notificationResource);
      }
    }
  };
  return (
    <div className="warehouse-recherche-container mb-2">
      <Stack direction="row" spacing={2} className="warehouse-recherche-module">
        <TextField
          data-testid={TestIds.SEARCH_TXT_FIELD}
          ref={inputFieldRef}
          component={"form"}
          id={"ID"}
          label="Identifiant"
          type="search"
          value={searchedId}
          onChange={onChangeSearchId}
          onSubmit={(e: React.SyntheticEvent) => {
            e.preventDefault();
            handleIdSearch();
          }}
          size="small"
        />
        <Button
          type="button"
          variant="contained"
          size="small"
          startIcon={<SearchRounded />}
          onClick={handleIdSearch}
          style={{
            width: "100%",
          }}>
          Rechercher
        </Button>
      </Stack>
      <Shortcuts />
    </div>
  );
}
